import cx from "classnames";
import { useTranslation } from "i18n";
import { AgenciesWithFilmmakers } from "component-library/src/components/Organisms/AppShell/navigation/helpers/getNavHeaderLinks";
import SeveralAgenciesWithMultipleFilmmakers from "component-library/src/components/Organisms/AgenciesWithFilmmakersPopUp/SeveralAgenciesWithMultipleFilmmakers";
import SeveralAgenciesWithOneFilmmaker from "component-library/src/components/Organisms/AgenciesWithFilmmakersPopUp/SeveralAgenciesWithOneFilmmaker";
import { Popup } from "../../Molecules/Popup/Popup";
import {
  NotificationToast,
  NotificationToastTypes,
} from "../../Atoms/NotificationToast/NotificationToast";

export const IS_FILMMAKERS_LOG_IN_MODAL_HIDDEN = "isFilmmakersLogInModalHidden";

interface Props {
  filteredAgenciesWithFilmmakers: AgenciesWithFilmmakers[];
  onHandleClose: () => void;
  handleCloseError: () => void;
  isOnlyOneAgencyLinkedToSpotlightAccount: boolean;
  handleLogIntoFilmmakersSSO: (
    agencyRefNumber: number,
    isHidden?: boolean
  ) => Promise<void>;
  isError: boolean;
}

const AgenciesWithFilmmakersPopUp = ({
  filteredAgenciesWithFilmmakers,
  onHandleClose,
  handleCloseError,
  isOnlyOneAgencyLinkedToSpotlightAccount,
  handleLogIntoFilmmakersSSO,
  isError,
}: React.PropsWithChildren<Props>) => {
  const { t } = useTranslation();

  const handleClose = () => {
    if (!isError) {
      onHandleClose();
    }
  };

  return (
    <Popup
      width={
        isOnlyOneAgencyLinkedToSpotlightAccount
          ? { lg: 5, md: 5 }
          : { lg: 8, md: 8 }
      }
      close={handleClose}
      priority="high"
      className={cx({
        "several-agencies-with-one-filmmaker":
          isOnlyOneAgencyLinkedToSpotlightAccount,
        "several-agencies-with-multiple-filmmakers":
          !isOnlyOneAgencyLinkedToSpotlightAccount,
      })}
    >
      {isOnlyOneAgencyLinkedToSpotlightAccount ? (
        <SeveralAgenciesWithOneFilmmaker
          handleClose={handleClose}
          handleSubmit={handleLogIntoFilmmakersSSO}
          agenciesWithFilmmakers={filteredAgenciesWithFilmmakers}
          isError={isError}
        />
      ) : (
        <SeveralAgenciesWithMultipleFilmmakers
          handleClose={handleClose}
          handleSubmit={handleLogIntoFilmmakersSSO}
          agenciesWithFilmmakers={filteredAgenciesWithFilmmakers}
          isError={isError}
        />
      )}
      {isError && (
        <div>
          <NotificationToast
            show={isError}
            text={t("common:errorPopup.httpStatus.generic.body")}
            type={NotificationToastTypes.Error}
            handleHide={() => {
              handleCloseError();
            }}
          />
        </div>
      )}
    </Popup>
  );
};

export default AgenciesWithFilmmakersPopUp;
